import React, { useState, useEffect, memo } from "react";
import "./HomepageBanner.css";

const Banner = ({ onLoad }) => {

  const [useHighRes, setUseHighRes] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Check network speed and update state accordingly.
  useEffect(() => {
    if (navigator.connection) {
      const connection = navigator.connection;
      // You can adjust the threshold as needed.
      if (connection.downlink && connection.downlink > 2) {
        setUseHighRes(true);
      }
    } else {
      // If navigator.connection is not available, assume a fast connection.
      setUseHighRes(true);
    }
  }, []);

  // Immediately unlock the rest of the page as soon as the banner mounts after delay of 0.5s.
  useEffect(() => {
    if (!useHighRes && onLoad) {
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [useHighRes, onLoad]);
  

  // Callback for when the index 0 image loads on high-speed connections.
  const handleImageLoad = () => {
    if (useHighRes) {
      setImageLoaded(true);
      if (onLoad) {
        onLoad();
      }
    }
  };

  return (
    <div className="banner-section container-fluid mb-5 p-0"
      // For high-speed: temporarily remove min-height before image loads.
      style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
    >
      <div
        id="carouselExampleCaptions"
        className={`carousel slide banner-visible `}
        data-bs-ride="carousel"
        data-bs-interval="2000"
        style={{width: "100%"}}
      >
        <div className="carousel-indicators carouselIndicators">
          {[...Array(4)].map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {[
            {
              src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%202.webp",
              heading: "For Corporates Growth",
              subheading: "TRAVEL SOLUTIONS",
              text: "Is business travel holding you back or pushing you forward? Not with our well-curated, cost-efficient corporate travel solutions!",
              link: "/corporate-travel",
              buttonText: "DISCOVER MORE",
            },
            {
              src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Technology.webp",
              heading: "With Tech Solutions",
              subheading: "GLOBAL EXPANSION",
              text: "Expanding your business across borders? Our tech solutions ease logistics, mobility, etc., making global expansion more efficient than ever.",
              link: "/tech-platform",
              buttonText: "EXPLORE MORE",
            },
            {
              src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Thoughts%20(1).webp",
              heading: "With Inspired Thoughts",
              subheading: "INNOVATIVE GROWTH",
              text: "How do great ideas turn into success? We help businesses find new opportunities and optimize operations to stay ahead in this evolving world.",
              link: "/consultation",
              buttonText: "LEARN HOW",
            },
            {
              src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%20(2).webp",
              heading: "With Curated Leisure",
              subheading: "BLEISURE TRAVEL",
              text: "Why choose between work and relaxation when you can have both? Let our expertly crafted bleisure travel experiences deliver you amazing leisure moments.",
              link: "/bliesure",
              buttonText: "THERE’S MORE",
            },
          ].map((item, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
              <picture>
                <source
                  media="(prefers-reduced-data: reduce)"
                  srcSet={index === 0 ? "/image1.png?w=480" : `${item.src}?w=480`}
                />
                <source
                  media="(prefers-reduced-data: no-preference)"
                  srcSet={index === 0 ? "/image1.png?w=1200" : `${item.src}?w=1200`}
                />
                <img
                  src={index === 0 ? "/image1.png" : item.src}
                  className="d-block w-100"
                  alt="..."
                  // For high-speed, use eager loading for index 0; for low-speed, use lazy loading.
                  loading={index === 0 ? (useHighRes ? "eager" : "lazy") : "lazy"}
                  // Attach onLoad handler only to the index 0 image on high-speed.
                  onLoad={index === 0 && useHighRes ? handleImageLoad : () => {}}
                  fetchpriority={index === 0 && useHighRes ? "high" : "auto"} // can be improved since on low speed we need image on priority too.
                />
              </picture>
              
              
              <div className="carousel-caption bannercarousel text-white mt-xxl-5 pt-xxl-3 mt-1">
                <p className="grotesk-headings mb-1">{item.subheading}</p>
                <h1 className="banner-headings w-100">{item.heading}</h1>
                <div className="d-flex common-second-content">
                  <div className="ornge-border"></div>
                  <div className="second-content">{item.text}</div>
                </div>
                <a href={item.link}>
                  <button className="fw-bold btn text-white fs5 text-uppercase">
                    {item.buttonText}
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);
